import React, {Fragment, useState, useRef, createContext, useContext, useEffect } from "react";
import "./xsolla-business-engine.css";
import "./xbeadd.css";
import { XBEhero2 } from "./XBEhero2";
import { XBEmenu } from "./XBEmenu";
import { XBEother } from "./XBEother";
import { XBEfooter } from "./XBEfooter";
import { XBEfeat } from "./XBEfeat";
import {XBEconf} from "./XBEconf";
import { XBEfilteredCards } from "./XBEfilteredCards";
import { BrowserRouter as Router, Route, Switch, withRouter, useLocation } from "react-router-dom";
import { XBEconfMobile } from "./XBEconfMobile";
import { XBEsiteCtaMagenta } from "./XBEsiteCtaMagenta";
import { XBEpaBanner } from "./XBEpaBanner";
import { mergeData, getData } from './airtable';
import { cardsTags } from "../../data/cards";
import { PAcardsConf } from './PAcardsConf';
import { PAcardBody } from './PAcardsBody';
import PAblue, { PAbluePage } from './PAblue';
import { CMStop } from '../cms/CMStop';
import { XbeContext } from './CardsPage';




// export const XBE2 = React.memo(
export function XBEmain(props) {

  const {
    cardId,
    type,
    // language='en',
    cms,
    history,
    match,
    location,
  } = {...props}
  // const {
  //   cardId,
  //   type,
  //   // language='en',
  //   cms,1
  //   history,
  //   match,
  //   location,
  // } = {...props}

  const [filters, setFilters] = useState([
    "pre_launch",
    "early_access",
    "live_game",
    "microtransactions",
    "premium",
    "subscriptions",
    "pc_mac",
    "web",
    "console",
    "mobile"
  ]);


  useEffect(() => {
    console.log('filters = ', filters);
    // debugger
  }, [filters])


  const cardsRef = useRef(null);

  const context = useContext(XbeContext);















  return (<Fragment>



      {filters && <Fragment>

      {Boolean(cms) &&
      <CMStop page={cms} language={context['language']} setLanguage={context['setLanguage']}/>}


        <XBEconf
          cardsRef={cardsRef}
          handleFilters={setFilters}
          filters={filters}
          type="mobile"
        ></XBEconf>

      {(!Boolean(cms) || cms === 'site') && <div className="l_landing_body">
        <XBEmenu language={context['language']} />

        <XBEhero2 language={context['language']}>
          <XBEconf
            language={context['language']}
            handleFilters={setFilters}
            filters={filters}
            type="web2"
          />
        </XBEhero2>

        <XBEother>
          <XBEfilteredCards

            pa={cms}

            language={context['language']}
            // ref={cardsRef}
            filters={filters}
            featured={true}
            // limit={2}
            // start={2}
          />
        </XBEother>

        <XBEpaBanner filters={filters} />

        {/* <XBEsiteCtaMagenta /> */}

        <XBEfooter />

      </div>}


      {cms === 'mobile' && <div className="mob0"><div className="mob_b"><div className="mob_card0"><div className="swiper_container"><div className="swiper_wrapper"><div className="swiper_slide swiper_slide--mobcard"><div className="mob_card"><div className="mob_card_title"><strong>Build direct relationships with players to grow your business</strong></div><div className="mob_card_desc">Create a loyal community, communicate with your players, and keep control of your cross-platform gamers’ data with our comprehensive distribution tools to represent your game.</div></div></div></div></div></div></div></div>}


      {cms === 'pa' && <div className="l_landing_body">



          <PAcardBody>
            {/* <XBEconfInner language={context['language']} handleFilters={setFilters} filters={filters} type="web2" /> */}
            <XBEconf
              cardsRef={cardsRef}
              handleFilters={setFilters}
              filters={filters}
              type="pa"
            ></XBEconf>


            <XBEfilteredCards

              // pa={true}


              language={context['language']}
              // ref={cardsRef}
              filters={filters}
              featured={true}
              // limit={2}
              // start={2}
            />
          </PAcardBody>

      </div>}



      {cms === 'all' && <div className="l_landing_body">



          <PAcardBody>
            {/* <XBEconfInner language={context['language']} handleFilters={setFilters} filters={filters} type="web2" /> */}
            <XBEconf
              cardsRef={cardsRef}
              handleFilters={setFilters}
              filters={filters}
              type="pa"
            ></XBEconf>


            <XBEfilteredCards

              pa={true}


              language={context['language']}
              // ref={cardsRef}
              filters={filters}
              featured={true}
              // limit={2}
              // start={2}
            />
          </PAcardBody>

      </div>}



    </Fragment>}

    {/* {!!cardId && <div className="">{cardId}</div>} */}

    </Fragment>
  );
}
// )



XBEmain.whyDidYouRender = true



// export default withRouter(XBE2);